(function() {
  'use strict';
  window.Brume = window.Brume || {};

/* ============================================
   FAQ ACCORDION — Expand / collapse logic
   ============================================ */

function initFaq() {
  const accordions = document.querySelectorAll('.faq-accordion');
  accordions.forEach(function(accordion) {
    if (accordion.dataset.faqInit) return; // guard against double-binding
    accordion.dataset.faqInit = '1';
    bindAccordion(accordion);
    openByDefault(accordion);
  });
}

/* An item rendered already open (markup carries .is-open) has no inline
   max-height, so give it a real one. Measured again after load because the
   install images are lazy and read as zero height until they arrive. */
function openByDefault(accordion) {
  const open = accordion.querySelector('.faq-item.is-open');
  if (!open) return;
  const answer = open.querySelector('.faq-answer');
  if (!answer) return;
  const size = function () {
    answer.style.transition = 'none';
    answer.style.maxHeight = answer.scrollHeight + 'px';
    void answer.offsetHeight;
    answer.style.transition = '';
  };
  size();
  window.addEventListener('load', size, { once: true });
  answer.querySelectorAll('img').forEach(function (img) {
    if (!img.complete) img.addEventListener('load', size, { once: true });
  });
}

function bindAccordion(accordion) {
  accordion.addEventListener('click', (e) => {
    const btn = e.target.closest('.faq-question');
    if (!btn) return;

    const item = btn.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const isOpen = item.classList.contains('is-open');

    /* Keep the tapped question where it is on screen. Closing an open item
       ABOVE it takes that answer's height out of the page, which moved
       everything below up by the same amount: opening "Will brume fit my
       faucet?" right after "How to Install" (an answer of about 1,170px)
       shrank the page by about 1,000px, left the reader at the bottom of the
       page and put the question they tapped off screen. So items above are
       collapsed instantly and the scroll moves by exactly what they removed.
       Items below cannot shift the tapped question and keep the animation.
       The shift is measured after layout rather than computed, so it stays
       right on browsers whose own scroll anchoring already corrected part of
       it (Chrome) and on those without any (Safari). */
    const topBefore = btn.getBoundingClientRect().top;
    let closedAbove = false;

    // Close all other items (accordion behaviour — one open at a time)
    accordion.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
      if (openItem !== item) {
        const openAnswer = openItem.querySelector('.faq-answer');
        const isAbove = openItem.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING;
        openItem.classList.remove('is-open');
        openItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        if (isAbove) {
          openAnswer.style.transition = 'none';
          openAnswer.style.maxHeight = '0';
          void openAnswer.offsetHeight;   // apply the collapse now, unanimated
          openAnswer.style.transition = '';
          closedAbove = true;
        } else {
          openAnswer.style.maxHeight = '0';
        }
      }
    });

    if (closedAbove) {
      const shift = btn.getBoundingClientRect().top - topBefore;
      // 'instant': <html> has scroll-behavior: smooth, which would animate it.
      if (shift) window.scrollTo({ top: window.scrollY + shift, behavior: 'instant' });
    }

    // Toggle the clicked item
    if (isOpen) {
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0';
    } else {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  });
}

  window.Brume.initFaq = initFaq;

  // Auto-initialize on any page that includes FAQ markup (no per-template call needed).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
})();
